import { Injectable } from "@angular/core";
import { CacheService } from "@delon/cache";
import { MemberService } from "@root/router/index/member.service";

@Injectable({
  providedIn: "root",
})
export class NewComerPromotionService {
  dispalyNewComerPromotion = false;
  constructor(private memberSrv: MemberService, private cacheSrv: CacheService) {}

  canDisplay() {
    return this.memberSrv.hasNewComerPromotion;
  }

  displayPromotion() {
    this.dispalyNewComerPromotion = true;
  }
  hidePromotion() {
    this.dispalyNewComerPromotion = false;
  }
}
